import oAxiosInstance from "config/Axios";

export const apiCallGetAllUnits = (sFilter = "") => {
  return oAxiosInstance.get(`unidades/${sFilter}`);
};
